module.exports = __webpack_public_path__ + "static/services-image-2_m-5f254725a363f9d9ca4339e4e0ffa015.jpg";